import { axios } from '@platform/rcl';

export function fetchLanguageStrings () {
  return (dispatch) => dispatch({
    type: 'FETCH_LANGUAGE_STRINGS',
    payload: axios().get('/api/auth/language-strings'),
  });
}
